// extracted by mini-css-extract-plugin
export default {"PostCreate":"qw_a bih_qt bih_a bih_w bih_ea"};